import * as XLSX from 'xlsx';

export interface ExportColumn {
  key: string;
  label: string;
  width?: number;
}

export interface ExportOptions {
  columns: ExportColumn[];
  data: any[];
  fileName: string;
  sheetName?: string;
  dateFrom?: Date | null;
  dateTo?: Date | null;
}

/**
 * Export data to Excel file
 */
export const exportToExcel = (options: ExportOptions): void => {
  const {
    columns,
    data,
    fileName,
    sheetName = 'Sheet1',
    dateFrom,
    dateTo
  } = options;

  // Prepare data for export
  const exportData = data.map((item) => {
    const row: any = {};
    columns.forEach((col) => {
      // Handle nested properties (e.g., 'book.title', 'user.fullName')
      const keys = col.key.split('.');
      let value = item;
      for (const key of keys) {
        value = value?.[key];
        if (value === undefined || value === null) break;
      }
      
      // Format value
      if (value instanceof Date) {
        row[col.label] = value.toLocaleDateString('vi-VN');
      } else if (typeof value === 'boolean') {
        row[col.label] = value ? 'Có' : 'Không';
      } else {
        row[col.label] = value ?? '';
      }
    });
    return row;
  });

  // Create workbook
  const wb = XLSX.utils.book_new();
  
  // Create worksheet
  const ws = XLSX.utils.json_to_sheet(exportData);

  // Set column widths
  const colWidths = columns.map((col) => ({
    wch: col.width || 15
  }));
  ws['!cols'] = colWidths;

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  // Generate filename with date range if provided
  let finalFileName = fileName;
  if (dateFrom || dateTo) {
    const dateStr = [
      dateFrom ? dateFrom.toLocaleDateString('vi-VN').replace(/\//g, '-') : '',
      dateTo ? dateTo.toLocaleDateString('vi-VN').replace(/\//g, '-') : ''
    ].filter(Boolean).join('_to_');
    finalFileName = `${fileName}_${dateStr}`;
  }
  finalFileName = `${finalFileName}_${new Date().toISOString().split('T')[0]}.xlsx`;

  // Write file
  XLSX.writeFile(wb, finalFileName);
};

/**
 * Format date for display
 */
export const formatDateForExport = (date: Date | string | null | undefined): string => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('vi-VN');
};

/**
 * Format datetime for display
 */
export const formatDateTimeForExport = (date: Date | string | null | undefined): string => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleString('vi-VN');
};

